import { render, staticRenderFns } from "./ProductComparisonsTable.vue?vue&type=template&id=c8970284&scoped=true&"
import script from "./ProductComparisonsTable.vue?vue&type=script&lang=js&"
export * from "./ProductComparisonsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductComparisonsTable.vue?vue&type=style&index=0&id=c8970284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8970284",
  null
  
)

export default component.exports